import { render, staticRenderFns } from "./ServicePhoto.vue?vue&type=template&id=d72908be&scoped=true&"
import script from "./ServicePhoto.vue?vue&type=script&lang=js&"
export * from "./ServicePhoto.vue?vue&type=script&lang=js&"
import style0 from "./ServicePhoto.vue?vue&type=style&index=0&id=d72908be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72908be",
  null
  
)

export default component.exports